import {
  EXPORT_MULTIPLE_CLIENT_REPORT_HTML,
  CLEAR_MULTIPLE_CLIENTS_REPORT_HTML
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';
import { createAction } from 'redux-actions';

export const {
  exportMultipleClientReportHtml,
  exportMultipleClientReportHtmlPending,
  exportMultipleClientReportHtmlFulfilled,
  exportMultipleClientReportHtmlRejected,
} = createAsyncActions(EXPORT_MULTIPLE_CLIENT_REPORT_HTML, 'exportMultipleClientReportHtml');


export const clearMultipleClientsReportHtml = createAction(CLEAR_MULTIPLE_CLIENTS_REPORT_HTML);




// WEBPACK FOOTER //
// ./src/features/reports/actions/exportMultipleClientReportHtmlActions.js